/**
 * Dev-only: sends logs to the Express dev server so they appear in the terminal.
 * This is needed because we can't access the WKWebView console in Excel Desktop.
 * Only POSTs in Office.js context (WKWebView); in a normal browser, console is enough.
 */
const DEV_LOG_URL = 'https://localhost:3001/api/debug/log'

const isOfficeContext = typeof window !== 'undefined' && 'Office' in window

export function devLog(level: 'info' | 'error' | 'warn', message: string, data?: unknown) {
  const fn = level === 'error' ? console.error : level === 'warn' ? console.warn : console.info
  fn(`[devLog] ${message}`, data)

  if (!isOfficeContext) return

  fetch(DEV_LOG_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ level, message, data: data instanceof Error ? { name: data.name, message: data.message, stack: data.stack, cause: String(data.cause) } : data }),
  }).catch(() => {})
}
